import React, { useState } from 'react';
import { Film, Tv, Radio, Smartphone, Bell, LogOut, BarChart2, DollarSign } from 'lucide-react';
import { FeedPublisher } from '../../components/publishers/FeedPublisher';
import { MoviePublisher } from '../../components/publishers/MoviePublisher';
import { EpisodePublisher } from '../../components/publishers/EpisodePublisher';
import { ShortsPublisher } from '../../components/publishers/ShortsPublisher';
import { AlertPublisher } from '../../components/publishers/AlertPublisher';
import VisitasContent from '../../components/publishers/VisitasContent';


export default function AdminPanelDesktop({ onLogout }: { onLogout: () => void }) {
  // 1. Adicionado 'ads' nas opções permitidas do menu
  const [activeTab, setActiveTab] = useState<'movies' | 'episodes' | 'feed' | 'shorts' | 'alerts' | 'visits' | 'ads'>('movies');

  return (
    <div style={{ backgroundColor: '#0A0A0A', color: '#fff', minHeight: '100vh', display: 'flex', fontFamily: 'system-ui, sans-serif' }}>
      
      {/* Menu Lateral Fixo do PC */}
      <div style={{ width: '220px', backgroundColor: '#111', borderRight: '1px solid #222', display: 'flex', flexDirection: 'column', padding: '15px 0', position: 'fixed', height: '100vh', boxSizing: 'border-box', zIndex: 100 }}>
        <div style={{ padding: '0 15px 15px 15px', borderBottom: '1px solid #222' }}>
          <h2 style={{ fontSize: '16px', fontWeight: '900', margin: '0 0 2px 0' }}>
            DOIS<span style={{ color: '#E50914' }}>PLAY</span>
          </h2>
          <span style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px' }}>Painel Admin</span>
        </div>

        <nav style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '15px 8px', flex: 1, overflowY: 'auto' }}>
          <button 
            onClick={() => setActiveTab('movies')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'movies' ? '#E50914' : 'transparent', color: activeTab === 'movies' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <Film size={15} /> Filmes
          </button>
          <button 
            onClick={() => setActiveTab('episodes')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'episodes' ? '#E50914' : 'transparent', color: activeTab === 'episodes' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <Tv size={15} /> Episódios
          </button>
          <button 
            onClick={() => setActiveTab('feed')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'feed' ? '#E50914' : 'transparent', color: activeTab === 'feed' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <Radio size={15} /> Feed
          </button>
          <button 
            onClick={() => setActiveTab('shorts')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'shorts' ? '#E50914' : 'transparent', color: activeTab === 'shorts' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <Smartphone size={15} /> Shorts
          </button>
          <button 
            onClick={() => setActiveTab('alerts')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'alerts' ? '#E50914' : 'transparent', color: activeTab === 'alerts' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <Bell size={15} /> Gerenciar Avisos
          </button>
          <button 
            onClick={() => setActiveTab('visits')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'visits' ? '#E50914' : 'transparent', color: activeTab === 'visits' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <BarChart2 size={15} /> Visitas
          </button>

          {/* 🚀 BOTÃO DE ANÚNCIOS ADICIONADO NO MENU LATERAL */}
          <button 
            onClick={() => setActiveTab('ads')}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: activeTab === 'ads' ? '#E50914' : 'transparent', color: activeTab === 'ads' ? '#fff' : '#aaa', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px', textAlign: 'left' }}>
            <DollarSign size={15} /> Anúncios
          </button>
        </nav>

        <div style={{ padding: '0 10px' }}>
          <button 
            onClick={onLogout}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '9px 12px', backgroundColor: 'rgba(255,255,255,0.05)', color: '#ff4d4d', border: '1px solid rgba(255,77,77,0.2)', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' }}>
            <LogOut size={14} /> Sair do Painel
          </button>
        </div>
      </div>

      {/* Conteúdo Principal do PC */}
      <div style={{ marginLeft: '220px', flex: 1, padding: '20px', boxSizing: 'border-box', overflowY: 'auto', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: '980px' }}>
          {activeTab === 'movies' && <MoviePublisher />}
          {activeTab === 'episodes' && <EpisodePublisher />}
          {activeTab === 'feed' && <FeedPublisher />}
          {activeTab === 'shorts' && <ShortsPublisher />}
          {activeTab === 'alerts' && <AlertPublisher />}
          {activeTab === 'visits' && <VisitasContent />}
          
        </div>
      </div>

    </div>
  );
}